import { Button, Dropdown } from 'antd'
import React, { useState } from 'react'
import { useTableContext } from './TableProvider'
import { MoreCircleIcon } from 'src/assets/icons'
import '../styles/index.scss'

const TableActionColumn: React.FC<{ data: any }> = (props) => {
  const { data } = props
  const { displayActionColumn, actionDropdownItems } = useTableContext()
  const [isDropdownVisible, setIsDropdownVisible] = useState(false)

  if (!displayActionColumn) {
    return <React.Fragment />
  }

  const handleDropdownVisibilityChange = (visible: boolean) => {
    setIsDropdownVisible(visible)
  }

  return (
    <Dropdown
      trigger={['click']}
      menu={{ items: actionDropdownItems?.(data) ?? [] }}
      onVisibleChange={handleDropdownVisibilityChange}
    >
      <Button
        className={`button-more-action ${isDropdownVisible ? 'active-button-more-action' : ''}`}
        icon={<MoreCircleIcon />}
      />
    </Dropdown>
  )
}

export default TableActionColumn
